import { useApi } from '../services';

export const useSavePersonRelationships = (idPerson) => useApi(`v2/person/${idPerson}/person-relationship`, 'POST', {}, {}, true);

export const useGetPersonRelationships = (idPerson) => useApi(`v2/person/${idPerson}/person-relationship`, 'GET', {}, {}, true);

export const usePersonRelationshipRestore  = (idPersonRelationship) => useApi(`v2/person/${idPersonRelationship}/restore`, 'PATCH', {}, {}, true);
